import { ROUTE_PATH } from '@shared/constants/route-path.enum';
import { USER_TYPE } from '@shared/models/UserType.model';

type SideBarConfig = {
  [key in USER_TYPE]: {
    id: string;
    path: ROUTE_PATH;
    label: string;
    isLoading: boolean;
    isHidden: boolean;
    icon: string;
  }[];
};

export const SIDEBAR_CONFIG: SideBarConfig = {
  [USER_TYPE.EXTERNAL_INSURED]: [
    {
      id: 'insured-history',
      path: ROUTE_PATH.INSURED_HISTORY,
      label: 'insuredHistory',
      icon: 'history',
      isHidden: false,
      isLoading: false
    },
    {
      id: 'correspondences',
      path: ROUTE_PATH.CORRESPONDENCES,
      label: 'correspondences',
      icon: 'note',
      isHidden: false,
      isLoading: false
    },
    {
      id: 'contributions',
      path: ROUTE_PATH.CONTRIBUTIONS,
      label: 'contributions',
      icon: 'receipt',
      isHidden: false,
      isLoading: false
    },
    {
      id: 'disability',
      path: ROUTE_PATH.DISABILITY,
      label: 'disability',
      icon: 'accessible',
      isHidden: false,
      isLoading: false
    },
    {
      id: 'certificates',
      path: ROUTE_PATH.CERTIFICATES,
      label: 'certificates',
      icon: 'file-check',
      isHidden: false,
      isLoading: false
    },
    {
      id: 'insurance-clearance-certification',
      path: ROUTE_PATH.INSURANCE_CLEARANCE_CERTIFICATION,
      label: 'insuranceClearanceCertification',
      icon: 'list-check',
      isHidden: false,
      isLoading: false
    },
    {
      id: 'iris-payment-history',
      path: ROUTE_PATH.IRIS_PAYMENT_HISTORY,
      label: 'irisPaymentHistory',
      icon: 'money',
      isHidden: false,
      isLoading: false
    }
  ]
};
